package pnemonic.balloon_pop.view.theme

import androidx.compose.ui.unit.dp

val sizeHomeButton = 60.dp
val sizeButton = 40.dp
val paddingButton = 8.dp
val paddingPanel = 8.dp
val paddingScreen = 24.dp

/**
 * The default size of the spacing between an icon and a text when they used inside a large button.
 */
val LargeIconSpacing = 12.0.dp //ButtonLargeTokens.IconLabelSpace
